var Backbone, EmailFormDropdownInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

EmailFormDropdownInputView = (function(superClass) {
  extend(EmailFormDropdownInputView, superClass);

  function EmailFormDropdownInputView() {
    return EmailFormDropdownInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormDropdownInputView.prototype.tagName = 'li';

  EmailFormDropdownInputView.prototype.events = {
    'change .dropdown_input': 'validateEmailForm'
  };

  EmailFormDropdownInputView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.isInputFieldEmpty = true;
    this.maxLength = 250;
    this.elementID = ".dropdown_input";
    this.template = this.options.template;
    this.model = this.options.model;
    this.isFlexibleStepThree = this.options.isFlexibleStepThree;
    this.label = this.model.label;
    this.dropdownOptions = this.getDropdownOptions(this.model.additional_attributes.options);
    return this.isInputCompulsory = this.model.required === true || this.model.required === "true";
  };

  EmailFormDropdownInputView.prototype.render = function() {
    this.$el.html(toHtml(this.template, this.toHash()));
    return $(this.elementID).datepicker();
  };

  EmailFormDropdownInputView.prototype.getDropdownOptions = function(options) {
    var dropdownOptions, i, len, option;
    dropdownOptions = [];
    for (i = 0, len = options.length; i < len; i++) {
      option = options[i];
      dropdownOptions.push({
        id: option,
        text: option
      });
    }
    return dropdownOptions;
  };

  EmailFormDropdownInputView.prototype.toHash = function() {
    return {
      stepThreeType: this.isFlexibleStepThree ? 'flexibleStepThree' : 'defaultStepThree',
      dropdown_input_template: true,
      label: this.label,
      required: this.isInputCompulsory,
      maxLength: this.maxLength,
      options: this.dropdownOptions,
      counter: this.model.counter
    };
  };

  EmailFormDropdownInputView.prototype.getInputHtmlElement = function() {
    return this.$el.find(this.elementID + " option:selected");
  };

  EmailFormDropdownInputView.prototype.isInputGiven = function() {
    var ref;
    return ((ref = this.readInput()) != null ? ref.length : void 0) > 0;
  };

  EmailFormDropdownInputView.prototype.readInput = function() {
    return this.getInputHtmlElement().val();
  };

  EmailFormDropdownInputView.prototype.isInputValid = function() {
    return true;
  };

  EmailFormDropdownInputView.prototype.validateEmailForm = function() {
    if (this.isInputCompulsory && ((this.isInputFieldEmpty && this.isInputGiven()) || !(this.isInputFieldEmpty || this.isInputGiven()))) {
      this.isInputFieldEmpty = !this.isInputGiven();
      return this.options.validateEmailForm();
    }
  };

  EmailFormDropdownInputView.prototype.populateInput = function(data) {
    var inputData;
    if (this.isInputGiven()) {
      inputData = this.readInput();
      return data.description += "\n\n " + this.label + " : " + inputData;
    }
  };

  return EmailFormDropdownInputView;

})(Backbone.View);

module.exports = EmailFormDropdownInputView;

//# sourceMappingURL=data:application/json;base64,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
